angular.module("app").controller("AddMediaPageController", [
    '$scope',
    '$rootScope',
    '$uibModalInstance',
    'mediaService',
    'errorHandler',
    'logger',
    'status',
    function ($scope, $rootScope, $modalInstance, mediaService, errorHandler, logger, status) {
        var init;
        (init = function () {
            $scope.image = {
                image: ""
            };
            $scope.draggedImage = undefined;
            $scope.submitData = undefined;
            $scope.status = status;
        })();

        /*
         *@ngdoc method
         *@name submitAddMediaForm
         *@description When you click on add button.
        */
        $scope.submitAddMediaForm = function () {
            if (!$scope.image.image && !$scope.draggedImage){
               $scope.showError = true;
               return;
            }
            var requestData = {
                media: angular.copy($scope.submitData)
            };
            mediaService.addImage(requestData).then(
                function (response) {
                    if (response.status === "ok") {
                        logger.logSuccess("media.imageCreated");
                        init();
                        $modalInstance.dismiss('cancel');
                    } else {
                        errorHandler(response.message)
                    }
                    $rootScope.$broadcast('mediasList.updateImages');
                },
                function (response) {
                    errorHandler(response.message)
                }
            )
        };

        /*
         *@ngdoc method
         *@name load
         *@description load image work dis function.
        */
        $scope.load = function (dataUrl) {
            $scope.submitData = {
                source: dataUrl.replace("data:image/svg+xml;", "data:image/svg;"),
                type: $scope.draggedImage.type,
                name: $scope.draggedImage.name
            }
        };

        $rootScope.$on("image:uploaded", function () {
            $scope.submitData = undefined;
        });

        $scope.cancel = function () {
            $modalInstance.dismiss('cancel');
        }
    }
]);
